//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";

export default {
    name: "TimelineProcessModal",
    components: {
        AQModal,
        Timeline: () => import("@/components/Flow/timeline.vue")
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        instanceID: {
            type: String,
            default: ""
        },
        instanceName: {
            type: String,
            default: ""
        },
        isFromPI: {
            type: Boolean,
            default: false
        },
        applicationId: {
            type: String,
            default: ""
        },
        isSmallScreen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            primaryBtn: {
                label: this.$t("generic.done")
            },
            modalValue: false
        };
    },
    computed: {
        getTitle() {
            return this.instanceName ? `${this.$t("timeline.timelineOf")} ${this.instanceName}` : this.$t("timeline.title");
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.modalValue = newValue;
            },
            immediate: true
        }
    },
    methods: {
        actions() {
            this.$emit("input");
            this.$emit("resetValues");
        }
    }
};
